function formatSeconds(seconds: number): string {
    const hours = Math.floor(seconds / (60 * 60));
    const divisor_for_minutes = seconds % (60 * 60);
    const minutes = Math.floor(divisor_for_minutes / 60);
    const divisor_for_seconds = divisor_for_minutes % 60;
    const secs = Math.floor(divisor_for_seconds);
    return `${hours > 0 ? `${hours}:` : ''}${numToTimeString(
        minutes,
    )}:${numToTimeString(secs)}`;
}

function numToTimeString(num: number): string {
    return num.toString().padStart(2, '0');
}

export default formatSeconds;
